import React, { useEffect, useState } from "react";
import { Descriptions } from "antd";
import { useIntl } from "react-intl";

import { SumItem } from "../colliForm/colliTableFooter";

const AdrSummary = ({
  quantity,
  maxCount,
  maxWeight,
  grossWeight,
  handlingUnitsQuantity,
}) => {
  const intl = useIntl();

  const [overQuantity, setOverQuantity] = useState();
  const [overGrossWeight, setOverGrossWeight] = useState();
  const [overHandlingUnitsQuantity, setOverHandlingUnitsQuantity] = useState();
  useEffect(() => {
    setOverQuantity(maxWeight < quantity);
    setOverGrossWeight(maxWeight < grossWeight);
    setOverHandlingUnitsQuantity(maxCount < handlingUnitsQuantity);
  }, [maxCount, maxWeight, quantity, grossWeight, handlingUnitsQuantity]);

  return (
    <Descriptions
      bordered
      column={4}
      size="small"
      className="colli-table-footer adr-footer"
    >
      <Descriptions.Item
        label={intl.formatMessage({
          id: "consignment.services.adr.quantity",
          defaultMessage: "Množství ADR látky",
        })}
      >
        <SumItem max={maxWeight} isOver={overQuantity} value={quantity} />
      </Descriptions.Item>
      <Descriptions.Item
        label={intl.formatMessage({
          id: "consignment.services.adr.handlingUnitsQuantity",
          defaultMessage: "Počet manipulačních jednotek",
        })}
      >
        <SumItem
          max={maxCount}
          isOver={overHandlingUnitsQuantity}
          value={handlingUnitsQuantity}
        />
      </Descriptions.Item>
      <Descriptions.Item
        label={intl.formatMessage({
          id: "consignment.services.adr.grossWeight.summary",
          defaultMessage: "Celková váha LQ",
        })}
      >
        <SumItem
          max={maxWeight}
          isOver={overGrossWeight}
          value={grossWeight > 0 ? grossWeight : "--"}
        />
      </Descriptions.Item>
    </Descriptions>
  );
};

export default AdrSummary;
